import isClient from './isClient';

const isRunningOnStagingServer =
  isClient() && window?.location?.hostname === 'consumer.stg.nest.joybird.com';

const isStagingServer = () => isRunningOnStagingServer;

export default isStagingServer;
